import { render } from "./MyShortName.vue?vue&type=template&id=3c83c1cb"
import script from "./MyShortName.vue?vue&type=script&lang=js"
export * from "./MyShortName.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__